import {Loading} from 'Components/Loading';
import React, {ReactElement} from 'react';
import {twMerge} from 'tailwind-merge';

interface Props {
    loading?: boolean;
    errored?: boolean;
    dark?: boolean;
}

export function LoadAndErrorWrapper({loading, errored, children, dark}: React.PropsWithChildren<Props>): ReactElement {
    return (
        <div className={twMerge('flex h-full w-full items-center justify-center', dark && 'bg-neutral-950')}>
            {(() => {
                if (loading) {
                    return <Loading />;
                }
                if (errored) {
                    return <h1 className="color-white font-bold">Sorry looks like something went wrong :( </h1>;
                }
                return children;
            })()}
        </div>
    );
}
